<template>
    <div>
        <v-row class="noprint">
            <v-col cols="8" md="8">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        RETURN DEFECTIVE PARTS
                    </span>
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4" mb="4" class="d-flex justify-end ">
                <v-text-field 
                class="mr-2"
                dense
                :disabled="disable_label"
                :rules="dhl_return_noR"
                v-model="save.dhl_return_no"
                label="DHL Number"
            />
              
                <v-btn rounded small v-if="disable_label == true" color="amber" class="mr-1" @click="edit()">
                    <v-icon class="mr-1" dark small >mdi-pencil</v-icon>
                    Edit</v-btn
                >
                <v-btn rounded small v-else  color="success" @click="save_number()"  class="mr-1">
                    <v-icon class="mr-1" dark small >mdi-content-save</v-icon>
                    Save</v-btn
                >
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
           
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-switch
                    v-model="chk_form"
                    class="ma-1 pa-3"
                    label="Form Asus"
                ></v-switch>
            </v-col>
        </v-row>

        <div id="printDiv">
            <div class="mt-5" v-for="(r, i) in data_print" :key="i">
                <div>
                    <div>
                        <table width="10%" style="float:left;">
                            <tr>
                                <td v-if="chk_form == false">
                                    <img
                                        v-if="r.company == 'HPI'"
                                        src="../../assets/return/HPBLACK.png"
                                        alt="Smiley face"
                                        height="50"
                                        width="50"
                                    />
                                    <img
                                        v-if="r.company == 'HPE'"
                                        src="../../assets/return/hp_enterprise_small.fw.png"
                                        alt="Smiley face"
                                    />
                                    <img
                                        v-if="r.company == 'ACA'"
                                        src="../../assets/logistic/Acacia.jpg"
                                        alt="Smiley face"
                                        height="80"
                                        width="80"
                                    />
                                </td>
                                <td v-else>
                                    <img
                                        src="../../assets/logistic/aserveicon.png"
                                        alt="Smiley face"
                                        height="45"
                                        width="90"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table width="84%">
                            <tr align="center">
                                <td colspan="6" v-if="chk_form == false">
                                    <span
                                        align="center"
                                        style="font-size: 16px;font-weight:bold;"
                                    >
                                        RETURN DEFECTIVE PARTS
                                    </span>
                                    <span style="float:right;"
                                        >{{ i + 1 }}/{{
                                            data_print.length
                                        }}</span
                                    >
                                </td>
                                <td colspan="6" v-else>
                                    <span
                                        align="center"
                                        style="font-size: 16px;font-weight:bold;"
                                    >
                                        RETURN PARTS FORM
                                    </span>
                                </td>
                            </tr>
                            <tr align="center">
                                <td colspan="6"></td>
                            </tr>
                            <tr>
                                <td
                                    style="font-size:14px;"
                                    width="20%"
                                    align="right"
                                >
                                    DELIVER TO LOGISTICS BY:
                                </td>
                                <td
                                    width="25%"
                                    style="border-bottom: 1px solid #000; font-size:14px;"
                                >
                                    {{ r.branch_min }}
                                </td>
                                <td
                                    style="font-size:14px;"
                                    width="9%"
                                    align="right"
                                >
                                    DATE:
                                </td>
                                <td
                                    width="23%"
                                    style="border-bottom: 1px solid #000; font-size:14px;"
                                >
                                    {{ r.create_date }}
                                </td>
                                <td
                                    style="font-size:14px;"
                                    width="10%"
                                    align="right"
                                >
                                    ACA-NO:
                                </td>
                                <td
                                    width="14%"
                                    style="border-bottom: 1px solid #000; font-size:14px;"
                                >
                                    {{ r.return_no }}
                                </td>
                            </tr>
                        </table>

                        <table width="23%">
                            <tr>
                                <td style="font-size:14px;" width="40%">
                                    SITE NO:
                                </td>
                                <td
                                    width="60%"
                                    style="border-bottom: 1px solid #000; font-size:14px;"
                                ></td>
                                
                            </tr>
                            <tr>
                                <td style="font-size:14px;">BADGE NO:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:14px;"
                                >
                                    E80000801
                                </td>
                             
                            </tr>
                        </table>
                      
                      
                    </div>

                    <div align="center" style="margin-top:10px;">
                        <table cellpadding="7" width="100%" border="1">
                            <tr align="center">
                                <td style="font-size:11px;" width="2%">
                                    <b>Item</b>
                                </td>
                                <td style="font-size:11px;" width="2%">
                                    <b>QTY</b>
                                </td>
                                <td style="font-size:11px;" width="11%">
                                    <b>Part No.</b>
                                </td>
                                <td style="font-size:11px;" width="38%">
                                    <b>Description</b>
                                </td>
                                <td style="font-size:11px;" width="12%">
                                    <b>Case No.</b>
                                </td>
                                <td style="font-size:11px;" width="6%">
                                    <b>Charge Code</b>
                                </td>
                                <td style="font-size:11px;" width="14%">
                                    <b>Customer Name</b>
                                </td>
                                <td style="font-size:11px;" width="3%">
                                    <b>CT</b>
                                </td>
                                <td style="font-size:11px;" width="3%">
                                    <b>Consumption Reason</b>
                                </td>
                                <td style="font-size:11px;" width="3%">
                                    <b>Trans Typs</b>
                                </td>
                                <td style="font-size:11px;" width="7%">
                                    <b>Red Tag No.</b>
                                </td>
                            </tr>

                            <tr v-for="(row, index) in r.parts" :key="index">
                                <td style="font-size:11px;" align="center">
                                    {{ index + 1 }}.
                                </td>
                                <td style="font-size:11px;" align="center">
                                    1
                                </td>
                                <td style="font-size:11px;" align="center">
                                    {{ row.part_name }}
                                </td>
                                <td style="font-size:11px;">
                                    {{ row.part_description }}
                                </td>
                                <td style="font-size:11px;" align="center">
                                    {{ row.ponumber }}
                                </td>
                                <td style="font-size:11px;" align="center">
                                    F
                                </td>
                                <td style="font-size:11px;" align="center">
                                    {{ row.rma }}
                                </td>
                                <td style="font-size:11px;" align="center">
                                    {{ row.ct_old }}
                                </td>
                                <td style="font-size:11px;" align="center">
                                    CM
                                </td>
                                <td style="font-size:11px;" align="center">
                                    {{ row.tran_type }}
                                </td>
                                <td style="font-size:11px;"></td>
                            </tr>
                        </table>

                        <table
                            width="100%"
                            style="margin-top:10px;"
                            v-if="chk_form == false"
                        >
                            <tr>
                                <td width="30%" style="font-size:13px;">
                                    <div style="float:left">
                                        Good Part Return
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </div>
                                    <div
                                        style="float:left;margin-left:15px; width: 10px; height: 10px; border: 1px solid black;
float: left; margin-top: 6px; "
                                    ></div>

                                    <div style="float:left;margin-left:5px;">
                                        test
                                    </div>
                                    <div
                                        style="float:left;margin-left:15px; width: 10px; height: 10px; border: 1px solid black;
float: left; margin-top: 6px; "
                                    ></div>
                                    <div style="float:left;margin-left:5px;">
                                        non-test
                                    </div>
                                </td>
                                <td width="3%">&nbsp;by</td>
                                <td
                                    width="20%"
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                ></td>
                                <td width="4%">Date</td>
                                <td
                                    width="20%"
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                >
                                    {{ r.create_date }}
                                </td>
                                <td width="30%"></td>
                            </tr>
                        </table>

                        <table width="20%" style="margin-top:10px; float:left">
                            <tr>
                                <td style="font-size:13px;">Sender:</td>
                                <td
                                    style="border-bottom: 1px solid #000;width: 110px; font-size:13px;"
                                >
                                    {{ r.create_name }}
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">Receiver:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                ></td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">Date:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                >
                                    {{ r.create_date }}
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">Time:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                >
                                    {{ r.create_time }}
                                </td>
                            </tr>
                        </table>

                        <table
                            width="15%"
                            style="float:left; margin-top:10px;"
                            v-if="chk_form == false"
                        >
                            <tr>
                                <td></td>
                                <td></td>
                                <td style="font-size:13px;">
                                    Consumption Reason
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td style="font-size:13px;">
                                    CM = Contract Maint.
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td style="font-size:13px;">
                                    PM = Preventive Maint.
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td style="font-size:13px;">
                                    INS = Installation
                                </td>
                            </tr>
                        </table>

                        <table
                            width="20%"
                            style="float:left"
                            v-if="chk_form == false"
                        >
                            <tr>
                                <td style="font-size:13px;">Charge Code:</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    K = Customer Contract Activity
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">F = Percall</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    N = New System Installation
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">W = Warranty</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    I = Add on Installation
                                </td>
                            </tr>
                        </table>

                        <table
                            width="20%"
                            style="float:left"
                            v-if="chk_form == false"
                        >
                            <tr>
                                <td style="font-size:13px;">Trans. Type:</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    1 = Routine on site Consumption
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    2 = Routine within Res.Area
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    3 = P-1Consumption
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">5 = DOA</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    G = GOOD PARTS returned****
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    NS = NON-SPARE PARTS
                                </td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    D = DEFECTIVE PARTS
                                </td>
                            </tr>
                        </table>

                        <table width="20%">
                            <tr>
                                <td style="font-size:13px;">
                                    For Logistic Only
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">Logistics:</td>
                            </tr>
                            <tr>
                                <td style="font-size:13px;">
                                    Date Entry Date:
                                </td>
                                <td
                                    style="border-bottom: 1px solid #000; width: 78px; font-size:13px;"
                                ></td>
                            </tr>
                            <tr>
                                <td>Time:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                ></td>
                            </tr>
                            <tr>
                                <td>Signature:</td>
                                <td
                                    style="border-bottom: 1px solid #000; font-size:13px;"
                                ></td>
                            </tr>
                        </table>

                        <table
                            width="99%"
                            style="margin-top:20px;"
                            v-if="chk_form == false"
                        >
                            <tr>
                                <td width="41%"></td>
                                <td width="5%"></td>
                                <td width="15%"></td>
                                <td style="font-size:13px;" width="13%">
                                    White : Logistics
                                </td>
                                <td style="font-size:13px;" width="13%">
                                    Blue : Messenger
                                </td>
                                <td style="font-size:13px;" width="13%">
                                    Pink : Engineer
                                </td>
                            </tr>
                        </table>

                        <table
                            width="99%"
                            style="margin-top:20px;"
                            v-if="chk_form == true"
                        >
                            <tr>
                                <td width="41%"></td>
                                <td width="5%"></td>
                                <td style="font-size:13px;" width="25%">
                                    FM-ASUS01-01 Rev.0 Eff. 1 Mar 2023 Internal
                                    Use Only
                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- <div
                        :class="
                            i + 1 != 1 && (i + 1) % 1 === 0 ? 'break-after' : ''
                        "
                    ></div> -->
                </div>
                <div style="page-break-after: always;"></div>
            </div>
         
        </div>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
    },
    mounted() {
        this.return_no = this.$route.params.return_no
        this.get_data()
    },
    methods: {
        test() {},
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "engineer/return-no/" + this.return_no)
                .then((response) => {
                    console.log("return-no/",response.data)
                    this.data_print = response.data
                    
                   
                    this.save.parts = response.data[0].parts
                    this.save.dhl_return_no = response.data[0].dhl_return_no
                    if(this.save.dhl_return_no == '' || this.save.dhl_return_no == null){
                        this.disable_label = false
                        this.disable_btn = false
                    }else{
                        this.disable_label = true
                        this.disable_btn = true
                       
                    }
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })

        },
        edit(){
            this.disable_label = false
        },
        async save_number() {
        // if(!this.disable_btn){
        //     this.disable_label = false
        // }
        console.log('defore',this.save.dhl_return_no)
        if(this.save.dhl_return_no==''){
            this.save.dhl_return_no = this.data_print[0].dhl_return_no
        }
        console.log('after',this.save.dhl_return_no)

            this.save.return_no = this.data_print[0].return_no
            this.dialog_loading = true
            console.log('save',this.save)
            await axios
                .post(url + "engineer/dhl-return-no",this.save,this.tk)
                .then((response) => {
                    console.log("return-save",response.data)
                    this.dialog_loading = false
                    this.get_data()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        back() {
            if (this.role_type == "Engineer") {
                this.$router.push("/Onsite/Main/Return-Part")
            } else {
                this.$router.push("/Return-Part")
            }
        },

        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/landscape.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            dialog_loading:false,
            save:{
                dhl_return_no:"",
                return_no:'',
                parts:[],
            },
        
            disable_btn:false,
            disable_label:false,
            return_no: 0,
            data_print: [],
            role_type: localStorage.role_type,
            chk_form: false,
        }
    },
}
</script>
<!-- <style lang="less" scoped>
button-action
</style> -->
